import { LoadingContainer, Spinner, LoadingText } from './LoadingSpinner.styled';

interface LoadingSpinnerProps {
  readonly text?: string;
}

export function LoadingSpinner({ text = 'Loading...' }: Readonly<LoadingSpinnerProps>) {
  return (
    <LoadingContainer>
      <Spinner />
      <LoadingText>{text}</LoadingText>
    </LoadingContainer>
  );
}
